var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "horizontal-product-card"
  }, [_c('div', {
    staticClass: "horizontal-product-card__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.groupBuying.product.images[0].pic_url
    }
  })]), _c('div', {
    staticClass: "horizontal-product-card__content"
  }, [_c('div', {
    staticClass: "horizontal-product-card__date"
  }, [_vm._v(_vm._s("".concat(_vm.startDate, "-").concat(_vm.endDate)))]), _c('div', {
    staticClass: "horizontal-product-card__title"
  }, [_vm._v(_vm._s(_vm.groupBuying.product.title))]), _c('div', {
    staticClass: "horizontal-product-card__subtitle"
  }, [_vm._v(_vm._s(_vm.groupBuying.sku.sku_name))]), _c('div', {
    staticClass: "horizontal-product-card__bottom s-flex s-groupBuyings-center s-justify-end"
  }, [_c('div', {
    staticClass: "horizontal-product-card__button"
  }, [_c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs btn-exchange",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.showGroupBuying(_vm.groupBuying.id);
      }
    }
  }, [_vm._v(" 查看 ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }